import React from 'react';
import { createRoot } from 'react-dom/client';
import classNames from 'classnames';

import RelatedItem from '@fec/frontend/modules/content/related-item/RelatedItem.jsx';
import { useTranslation } from 'react-i18next';

import '@fec/frontend/modules/groups-and-lists/related-items-list/related-items-list.scss';

export function init() {
  document.querySelectorAll('.js-materialbox').forEach((container) =>
    createRoot(container).render(
      <React.StrictMode>
        <MaterialBox
          heading={container.dataset.listHeading}
          video={JSON.parse(container.dataset.video)}
          links={JSON.parse(container.dataset.links)}
          currentArticleId={container.dataset.currentArticleId}
        />
      </React.StrictMode>,
    ),
  );
}

const MaterialBox = ({
  video,
  currentArticleId = null,
  heading,
  links = [],
}) => {
  const { t } = useTranslation();

  return (
    <div className="related-items-list related-items-list--aron related-items-list--materialbox">
      {heading && <h2 className="related-items-list__heading">{heading}</h2>}

      <ul className="related-items-list__list">
        <li key={video.urn} className="related-items-list__item-wrapper">
          <RelatedItem
            item={video}
            currentArticleId={currentArticleId}
            modifier="related-item--materialbox"
          />
          {links.length > 0 && (
            <div className="linkbox linkbox--materialbox">
              <h2 className="linkbox__title">{t('materialbox.links.title')}</h2>
              <ul className="linkbox__list">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.link}
                      data-urn=""
                      data-title=""
                      className={classNames('block-link', {
                        'block-link--pdf': link.variety === 'pdf',
                        'block-link--docx': link.variety === 'docx',
                      })}
                      download={link.filename ?? link.title}
                      data-download-event-track={link.filename ?? link.title}
                      target="_blank"
                      rel="noreferrer">
                      <span className="block-link__title">{link.title}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </li>
      </ul>
    </div>
  );
};

export default MaterialBox;
